export default function Skills(){
    return (
        <section className="skills">
            <div className="left">
                <div className="text">Full Stack Developer</div>
            </div>
            <div className="right">
                <div className="skills-wrapper">
                    <div className="skill">flutter</div>
                    <div className="skill">javascript</div>
                    <div className="skill">django</div>
                    <div className="skill">python</div>
                </div>
                <div className="buttons-wrapper">
                    <div className="skil-btn active"></div>
                    <div className="skil-btn"></div>
                    <div className="skil-btn"></div>
                    <div className="skil-btn"></div>
                </div>
            </div>
        </section>
    )
}